import { useQuery } from '@tanstack/react-query';
import { Endpoint, QueryKey } from '@/constants';
import type { County } from '@/types';
import { getData } from '@/utils/getData';

export const useGetCounties = (countryCode: string): County[] => {
  const { data } = useQuery({
    enabled: Boolean(countryCode),
    queryFn: getData(Endpoint.GetCounties, { countryCode }),
    queryKey: [QueryKey.Counties, { countryCode }],
  });

  return data ?? [];
};
